import React from 'react';
import { motion } from 'framer-motion';

export const AnimatedToken = ({ from, to, color, label, delay = 0, scale = 1 }) => {
  const particles = [0, 1, 2];
  return (
    <g>
      {/* Trail line */}
      <motion.line
        x1={from.x} y1={from.y} x2={to.x} y2={to.y}
        stroke={color}
        strokeWidth={2 * scale}
        strokeDasharray={`${6 * scale} ${8 * scale}`}
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 0.25 }}
        transition={{ duration: 0.5, delay }}
      />
      {/* Particle trail */}
      {particles.map((p) => (
        <motion.circle
          key={p}
          r={(5 - p * 1.2) * scale}
          fill={color}
          style={{
            filter: `drop-shadow(0 0 ${(10 - p * 2) * scale}px ${color})`,
            mixBlendMode: 'screen'
          }}
          initial={{ cx: from.x, cy: from.y, opacity: 0 }}
          animate={{
            cx: to.x, cy: to.y,
            opacity: [0, 1, 1, 0.3, 0],
            scale: [0.5, 1.3, 1, 0.6, 0.3]
          }}
          transition={{
            duration: 1.6,
            ease: "circOut",
            repeat: Infinity,
            delay: delay + p * 0.15
          }}
        />
      ))}
      {/* Label on the midpoint */}
      {label && (
        <motion.g
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: delay + 0.3 }}
        >
          <rect
            x={(from.x + to.x) / 2 - 40 * scale}
            y={(from.y + to.y) / 2 - 14 * scale}
            width={80 * scale} height={28 * scale} rx={14 * scale}
            fill={color}
            opacity="0.95"
            stroke="rgba(255,255,255,0.5)"
            strokeWidth={1.5 * scale}
          />
          <text
            x={(from.x + to.x) / 2}
            y={(from.y + to.y) / 2 + 5 * scale}
            textAnchor="middle"
            fill="#fff"
            fontSize={14 * scale}
            fontWeight="1000"
            style={{ textShadow: `0 ${1 * scale}px ${4 * scale}px rgba(0,0,0,0.8)` }}
          >
            {label}
          </text>
        </motion.g>
      )}
    </g>
  );
};
